const equipments = {
	title: "Utstyr",
	stitle: "Utstyr",
	new_title: "Nytt utstyr",
	edit_title: "Endre: {name}",
	list_title: "Utstyrsliste",
	list_subtitle: "Endre utstyr",
	id: "ID",
	serial_number: "Serienummer",
	model_details: "Modeldetaljer",
	internal_nb: "Internnummer",
	year: "År",
	inspection_interval: "Kontrollintervall",
	next_inspection_date: "Neste kontroll",
	qr_code: "QR kode",
	swl: "SWL",
	responsible_by: "Ansvarlig",
	company_id: "Selskap",
	notes: "Notat",
	urls: "URL",
};
export default equipments;